import type { SearchTileDensity } from '../searchTileDensity'

/**
 * CRO compact density must stay a single horizontal row (CRO-6924).
 * Grouped option cards break that geometry, so secondary/grouped alternatives
 * intentionally collapse to the primary single-row tile for the experiment.
 * Map rows and cards also use only the primary offer; grouping is excluded from map searches.
 * Legacy Optimizely compact density still allows grouped tiles.
 */
export function shouldUseGroupedAccommodationSearchTile({
  density,
  hasSecondaryOffer,
  isMetaSearch = false,
}: {
  density: SearchTileDensity
  hasSecondaryOffer: boolean
  isMetaSearch?: boolean
}): boolean {
  return density !== 'cro-compact' && density !== 'map-row' && density !== 'map-card' && hasSecondaryOffer && !isMetaSearch
}
